module.exports = __webpack_public_path__ + "media/images/add-24px-03f3aa6e554544423c9a9a53e72adbaf.svg";